module.exports = __webpack_public_path__ + "static/media/tarifs.a02e6ebd.xls";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/form/tarifs.xls
// module id = 835
// module chunks = 40